import React from 'react';
import { defineNextPage } from '@/common/next';
import OfficialHomeContent from '@/components/overseaHome/OfficialHomeContent';
import OfficialHomeHead from '@/components/overseaHome/OfficialHomeHead';
import type { OfficialHomePageProps } from '@/components/overseaHome/types';
import { getOfficialHomePageData } from '@/apiSdk/officialHomePageData';

export default defineNextPage<OfficialHomePageProps>({
  pageConfig: {
    projectId: '/--oversea',
    layoutId: 'OverseaLayout',
    /** 海外官网独立保留页面配置，当前共用官网 SEO。 */
    renderHead() {
      return <OfficialHomeHead />;
    },
  },
  getInitialProps: getOfficialHomePageData,
  /** 页面工厂会挂载 pageConfig，入口必须使用独立函数，避免覆盖国内页面配置。 */
  component: function OverseaOfficialHome(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <OfficialHomeContent {...props} />;
  },
});
